export default __webpack_public_path__ + "static/media/key.c4bf05a0.png";